// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "hotelfinder" + "." + "b9578d3d4184e4939481" + ".css";
};